import {
  AutoComplete,
  Breadcrumb,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
// import { t } from "i18next";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
// import NumberField from "../../common/htmlComponents/NumberField";
// import { PlusOutlined } from "@ant-design/icons";
// import InputField from "../../common/htmlComponents/InputField";
// import { TimePicker } from "antd";
import FormItem from "antd/es/form/FormItem";
// import TextArea from "antd/lib/input/TextArea";
import { Link, useNavigate, useParams } from "react-router-dom";
// import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
// import moment from "moment";
// import { Option } from "antd/lib/mentions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
// import EmailField from "../../common/htmlComponents/EmailField";
import { authUserData } from "../../utils/Helper";
// import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { LoadScript } from "@react-google-maps/api";
export default function EditRoutePackage() {
  const formRef = useRef();
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const { id } = useParams();
  const PackageId = id ? atob(id) : null;
  const { Option } = Select;
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [weightList, setWeightList] = useState([]);
  const [suburbSearchList, setSuburbSearchList] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [companyList, setCompanyList] = useState([]);
  // const [disabled, setDisabled] = useState(true);
  const libraries = ["places"];

  const initialState = {
    hawb: "",
    customer_code: "",
    customer_name: "",
    customer_phone: "",
    customer_address: "",
    postcode: "",
    description_of_goods: "",
    count: "",
    landed: "",
    weight: "",
    height: "",
    length: "",
    volume_weighted: "",
    shipper_code: "",
    shipper_name: "",
    shipper_address: "",
    shipper_city: "",
    shipper_state: "",
    shipper_postcode: "",
    shipper_country: "",
    origin: "",
    port: "",
    total_value: "",
    goods_currency: "",
    sac: "",
    fr_reference: "",
    sub_master: "",
    pkg_type: "",
    country_of_origin: "",
    cyber_vendor_account: "",
    customs_code: "",
    cyber_importer_account: "",
    importer_abn: "",
    importer_cac: "",
    cyber_supplier_account: "",
    supplier_customs_code: "",
    parcel_no: 0,
    status: "",
    is_scanned: "",
    delivery_date: "",
    price: "",
    company: null,
    // zones: authUserData()?.zones ? authUserData()?.zones : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    // suburb: authUserData()?.suburb ? authUserData()?.suburb : 1,
    country: authUserData()?.country ? authUserData()?.country : 1,
    // country:null,
    suburb: null,
    zone: null,
  };

  const [state, setState] = useState(initialState);
  const [deliverydate, setdeliverydate] = useState(null);
  const [checked, setChecked] = useState(false);
  // const inputRef = useRef(null);
  // const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  // const format = "HH:mm";
  // const [countries, setCountries] = useState([]);

  // const handleInputChange = (e) => {
  //   let { name, value } = e.target;
  //   setState({ ...state, [name]: value });
  // };
  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=true", data).then((response) => {
      setCompanyList(response.data.data);
    });
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  //const phoneValidLength = state?.customer_phone;
  // const validatePhoneNumber = () => {
  //   if (
  //     (phoneValidLength && phoneValidLength.length < 8) ||
  //     phoneValidLength === null ||
  //     phoneValidLength === ""
  //   ) {
  //     return Promise.reject(new Error("Please enter valid phone."));
  //   }

  //   return Promise.resolve();
  // };

  const handlePostCodeChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      postcode: value,
    }));
  };
  // const handleSuburbChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     suburb: value,
  //     postcode: null,
  //   }));
  //   formRef.current.setFieldsValue({ postcode: null });
  //   setPostCodes([]);
  //   getPostCodeBySuburb(value);
  // };

  const searchINBilling = async (value, id) => {
    const apiResponse = await getRequest(
      // `pincode/?search_pincode_number=${value}`
      `suburb/?zone_id=${state.zone}&search_area=${value}`
      //  `suburb/?no_pagination=true&suburb_id=${id}`
    );

    if (apiResponse.data.results.success) {
      setSuburbSearchList(apiResponse.data.results.data);
    }
  };
  // const handleWeightChange = (value) => {
  //   // Find the zone name based on the selected zone id
  //   const selectedWeight = weightList?.find((zone) => zone.id === value);
  //   const weightName = selectedWeight ? selectedWeight.unit_of_measurement : "";
  //   setState((prevState) => ({
  //     ...prevState,
  //     weight: value,
  //     price: null,
  //   }));
  //   formRef.current.setFieldsValue({ price: null });
  //   // setPostCodes([]);
  //   getPriceByWeight(weightName);
  // };
  // const handleWeightChange = (value) => {
  //   // Find the zone name based on the selected zone id

  //   setState((prevState) => ({
  //     ...prevState,
  //     weight: value,
  //     price: null,
  //   }));
  //   formRef.current.setFieldsValue({ price: null });
  //   // setPostCodes([]);
  //   getPriceByWeight(weightName);

  // };

  const handleWeightChange = useCallback(
    (e) => {
      const value = e.target.value;

      // Update weight and reset price
      setState((prevState) => ({
        ...prevState,
        weight: value,
        price: null, // Reset price when weight changes
        currency: null,
      }));

      // Reset the price field in the form
      formRef.current.setFieldsValue({ price: null });

      // Validate that zone, company, and weight are available before making the API call
      if (state.zone && state.company && value) {
        getPriceByWeight(value); // Call the API if validation passes
      } else {
        console.log("Missing required fields: zone, company, or weight");
      }
    },
    [state, formRef]
  );
  const handleCompanyChange = (value) => {
    // getPermissionByCountry(value);
    setState((prevState) => {
      return {
        ...prevState,
        company: value,
        weight: null,
        price: null,
      };
    });
    formRef.current.setFieldsValue({ weight: null, price: null });
    // setStates([]);
    // getStateByCountry(value);
  };

  // Async function to fetch price based on weight
  const getPriceByWeight = async (weight) => {
    try {
      const response = await getRequest(
        `package-model/get-price-by-delivery-rate/?zone=${state.zone}&company=${state.company}&weight=${weight}`
      );
      if (response?.status) {
        const { price, currency } = response.data;

        // Set price and currency in state
        setState((prevState) => ({
          ...prevState,
          price,
          currency,
        }));

        // Display price and currency in the form field (as a single string)
        formRef.current.setFieldsValue({ price: `${price} ${currency}` });
      }
    } catch (error) {
      console.error("Error fetching price by weight", error);
    }
  };
  const onSearchBilling = async (value, id) => {
    // setSearch(!value ? "" : value);

    setSearchValueBilling(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 3
      ? searchINBilling(!value ? null : value)
      : setSuburbSearchList([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };
  // const getPriceByWeight = async (weightName) => {
  //   const pincodeResponse = await getRequest(
  //     // `delivery-rates/?state=${state?.state}&zone=${state?.zone_name}&unit_of_measurement=${weightName}&no_pagination=true`
  //     `package-model/get-price-by-delivery-rate/?zone=${state?.zone}&company=${state?.company}&weight=1`
  //   );

  //   if (pincodeResponse?.data.success) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       price: pincodeResponse?.data?.data[0]?.price,
  //       // price: null,
  //     }));
  //     formRef.current.setFieldsValue({ price: pincodeResponse?.data?.data[0]?.price });
  //   }
  //   //  setZones(zoneResponse?.data?.data);
  // };
  // const getPostCodeBySuburb = async (id) => {
  //   const pincodeResponse = await getRequest(
  //     "pincode/?no_pagination=true&suburb_id=" + id
  //   );
  //   const pincode = pincodeResponse?.data?.data.map((pincode) => ({
  //     id: pincode.id,
  //     name: pincode.pincode,
  //   }));
  //   setPostCodes(pincode);

  //   //  setZones(zoneResponse?.data?.data);
  // };
  const getPostCodeBySuburb = async (id) => {
    const pincodeResponse = await getRequest(
      "pincode/?no_pagination=true&suburb_id=" + id
    );
    const pincodeData = pincodeResponse?.data?.data;

    if (pincodeData && pincodeData.length > 0) {
      // Assuming you want to set the first pincode as the selected one
      setState((prevState) => ({
        ...prevState,
        postcode: pincodeData[0].pincode, // Set the pincode value
        postcodeId: pincodeData[0].id, // Store the ID of the pincode
      }));
      const pincode = pincodeResponse?.data?.data.map((pincode) => ({
        id: pincode.id,
        name: pincode.pincode,
      }));
      setPostCodes(pincode);
    }
  };
  const handleCountryChnage = (value) => {
    setState((prevState) => ({
      ...prevState,
      country: value,
    }));
  };

  // const handleZoneChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     zone: value,
  //     suburb: null,
  // postcode:null,
  //   }));
  //   formRef.current.setFieldsValue({ suburb: null ,postcode:null});
  //   setSuburbList([]);
  //   setPostCodes([])
  //   //  setZones([]);
  //   getSuburbByzone(value);
  //   getWeightByZone(zoneName);
  // };

  const handleZoneChange = (value) => {
    // Find the zone name based on the selected zone id
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";

    // Update state and reset suburb/postcode lists
    setState((prevState) => ({
      ...prevState,
      zone: value,
      zone_name: zoneName,
      suburb: null,
      postcode: null,
      weight: null,
      price: null,
    }));

    formRef.current.setFieldsValue({
      suburb: null,
      postcode: null,
      price: null,
      weight: null,
    });
    // setSuburbList([]);
    setSuburbSearchList([]);
    setWeightList([]);
    setPostCodes([]);

    // Call API functions with the zoneName
    // getSuburbByzone(value); // This might still need the zone id
    getWeightByZone(zoneName); // Pass the zoneName instead of the id
  };

  const getWeightByZone = async (zoneName) => {
    try {
      setapiLoading(true);

      const weightResponse = await getRequest(
        `delivery-rates/?state=${state.state}&zone=${zoneName}&no_pagination=true`
      );

      if (weightResponse.data.success) {
        setWeightList(weightResponse?.data?.data);
      }

      setapiLoading(false);
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setapiLoading(false);
    }
  };

  useEffect(() => {
    const zoneGetById = async () => {
      if (PackageId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`package-model/${PackageId}/`);

          if (response.data.success) {
            const {
              id,
              zone_name,
              // city_name,
              state_name,
              pincode,
              suburb_name,
              country_name,
              // parcel_no,
              // delivery_date,
              company_name,
              ...filteredResponse
            } = response.data.data;

            // Example condition: clone if `someKey` is truthy
            //   const shouldClone = Boolean(response.data.data.someKey);
            // shouldClone
            //     ? cloneDeep(filteredResponse)
            //     : filteredResponse;

            setState((prevState) => ({
              ...filteredResponse,
              postcode: Number(response.data.data.postcode_name),
            }));

            const formValues = {
              state: response.data.data.state_name,
              country: response.data.data.country_name,
              suburb: response.data.data.suburb_name,
              zone: response.data.data.zone_name,
              hawb: response.data.data.hawb,
              delivery_date: response.data.data.delivery_date
                ? moment(response.data.data.delivery_date, "DD-MM-YYYY HH:mm")
                : null,
              customer_code: response.data.data.customer_code,
              customer_name: response.data.data.customer_name,
              customer_phone: response.data.data.customer_phone,
              customer_address: response.data.data.customer_address,
              postcode: Number(response.data.data.postcode_name),
              description_of_goods: response.data.data.description_of_goods,
              count: response.data.data.count,
              landed: response.data.data.landed,
              weight: response.data.data.weight,
              height: response.data.data.height,
              length: response.data.data.length,
              volume_weighted: response.data.data.volume_weighted,
              shipper_code: response.data.data.shipper_code,
              shipper_name: response.data.data.shipper_name,
              shipper_address: response.data.data.shipper_address,
              shipper_city: response.data.data.shipper_city,
              shipper_state: response.data.data.shipper_state,
              shipper_postcode: response.data.data.shipper_postcode,
              shipper_country: response.data.data.shipper_country,
              origin: response.data.data.origin,
              port: response.data.data.port,
              total_value: response.data.data.total_value,
              goods_currency: response.data.data.goods_currency,
              sac: response.data.data.sac,
              fr_reference: response.data.data.fr_reference,
              sub_master: response.data.data.sub_master,
              pkg_type: response.data.data.pkg_type,
              country_of_origin: response.data.data.country_of_origin,
              cyber_vendor_account: response.data.data.cyber_vendor_account,
              customs_code: response.data.data.customs_code,
              cyber_importer_account: response.data.data.cyber_importer_account,
              importer_abn: response.data.data.importer_abn,
              importer_cac: response.data.data.importer_cac,
              cyber_supplier_account: response.data.data.cyber_supplier_account,
              supplier_customs_code: response.data.data.supplier_customs_code,
              parcel_no: response.data.data.parcel_no,
              status: response.data.data.status,
              is_scanned: response?.data?.data?.is_scanned,
              price: response?.data?.data?.price,
              company: response?.data?.data?.company,
            };

            getStateByCountry(response?.data?.data?.country);
            getzoneByState(response?.data?.data?.state);
            getSuburbByzone(response?.data?.data?.zone);
            if (response?.data?.data?.suburb) {
              getPostCodeBySuburb(response?.data?.data?.suburb);
            }

            if (formRef.current) {
              formRef.current.setFieldsValue(formValues);
            }
          }
        } catch (error) {
          console.error("Error fetching package:", error);
        } finally {
          setapiLoading(false);
        }
      }
    };

    zoneGetById();
  }, [PackageId]);

  useEffect(() => {
    if (PackageId === null) {
      // getZones();
      getCountryName();
      authUserData()?.country ? getStateByCountry(1) : getStateByCountry(1);
      authUserData()?.state
        ? getzoneByState(authUserData()?.state)
        : getzoneByState(1);
      // authUserData()?.zone
      //   ? getSuburbByzone(authUserData()?.zone)
      //   : getSuburbByzone(1);
      authUserData()?.country && authUserData()?.state
        ? formRef.current.setFieldsValue({
            country: authUserData()?.country_name,
            state: authUserData()?.state_name,
          })
        : console.log("");
    }
    // getZoneBySuburb();
  }, []);

  const [zones, setZones] = useState([]);
  const [postCodes, setPostCodes] = useState([]);
  const [countries, setCountries] = useState([]);
  // const [suburbList, setSuburbList] = useState([]);
  const [states, setStates] = useState([]);

  // const getCountryName = async () => {
  //   try {
  //     const response = await getRequest("country/?no_pagination=true&state_id=" + id);
  //     const countries = response?.data?.data.map((country) => ({
  //       id: country.name,
  //       name: country.Country,
  //     }));
  //     setCountries(countries); // Assuming setCountries is a state updater function
  //   } catch (error) {
  //     console.error("Error fetching countries:", error);
  //   }
  // };
  const getCountryName = async (id) => {
    const stateResponse = await getRequest("country/?no_pagination=true");

    setCountries(stateResponse?.data?.data);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      zone: null,
      // suburb: null,
    }));
    formRef.current.setFieldsValue({ zone: null });
    setZones([]);
    // setSuburbList([]);
    // setZones([]);
    getzoneByState(value);
  };
  const getzoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };
  // const handleCityChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     city: value,
  //     suburb: null,
  //     zone: null,
  //   }));
  //   formRef.current.setFieldsValue({ suburb: null, zone: null });
  //   setSuburbList([]);
  //   setZones([]);
  //   getSuburbByCity(value);
  // };
  const getSuburbByzone = async (id, value, suburb) => {
    try {
      setapiLoading(true);
      const suburbResponse = await getRequest(
        //"suburb/?no_pagination=true&suburb_id=" + id
        `suburb/?zone_id=${id}`
        //`suburb/?zone_id=${id}&search_area=${suburb}`
      );
      // if (suburbResponse.data.success) {
      //   setSuburbList(suburbResponse?.data?.data);

      //   setapiLoading(false);
      // }
      if (suburbResponse.data.results.success) {
        setSuburbSearchList(suburbResponse.data.results.data);
      }
      handleSuburbSearchChange();
    } catch {
      // ErrorNotificationMsg(t("Error fetching suburb"));
      setapiLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked); // Set the checkbox state

    // Update the is_scanned state based on the checkbox state
    setState((prevState) => ({
      ...prevState,
      is_scanned: isChecked, // true if checked, false if unchecked
    }));
  };

  // const handleCheckboxvisitedChange = (e) => {
  //   setChecked(e.target.checked);
  //   setState((prevState) => ({
  //     ...prevState,
  //     visited: e.target.checked,
  //   }));
  // };

  // const handleCheckboxdepartedChange = (e) => {
  //   setChecked(e.target.checked);
  //   setState((prevState) => ({
  //     ...prevState,
  //     departed: e.target.checked,
  //   }));
  // };
  // end new
  // const handleSuburbSearchChange = async (suburb, value) => {
  //   if (suburb !== null && suburb !== undefined && suburb !== "" && suburb.length > 2) {
  //     try {
  //       const response = await getRequest(
  //         // `pincode/?search_pincode_number=${billing_pincode}`
  //         `suburb/?zone_id=${state.zone}&search_area=${suburb}`
  //       );
  //       if (response.data.results.success) {
  //         // setSuburbSearchList(response.data.results.data);
  //         setState((prevState) => ({
  //           ...prevState,
  //           suburb: id
  //         }));
  //       }

  //       // setApiLoading(false);
  //     } catch (error) {
  //       // setApiLoading(false);
  //     }
  //   }

  // };
  const handleSuburbSearchChange = (value) => {
    // const selectedWeight = suburbSearchList?.find((id) => id === value);
    //const weightName = selectedWeight ? selectedWeight.area : "";
    const selectedSuburb = suburbSearchList.find(
      (option) => option.id === value
    );
    if (selectedSuburb) {
      setState((prevState) => ({
        ...prevState,
        suburb: value, // Set the area name instead of ID
        postcode: null,
      }));

      formRef.current.setFieldsValue({
        postcode: null,
        suburb: selectedSuburb.area,
      });

      setPostCodes([]);
    }
    if (selectedSuburb?.id) {
      getPostCodeBySuburb(selectedSuburb?.id);
    } else {
      console.log("error in suburb");
    }
  };
  const handleSubmit = async () => {
    const payload = {
      // ...state,
      // geofence_visited_time: state.geofence_visited_time || null,
      hawb: state.hawb || null,
      customer_code: state.customer_code || null,
      customer_name: state.customer_name || null,
      customer_phone: state.customer_phone || null,
      customer_address: state.customer_address || null,
      // postcode: state.postcode || null,
      postcode: state.postcodeId || null, // This is the pincode ID
      description_of_goods: state.description_of_goods || null,
      count: state.count || null,
      landed: state.landed || false,
      weight: state.weight || null,
      shipper_code: state.shipper_code || null,
      shipper_name: state.shipper_name || null,
      shipper_address: state.shipper_address || null,
      shipper_city: state.shipper_city || null,
      shipper_state: state.shipper_state || null,
      shipper_postcode: state.shipper_postcode || null,
      shipper_country: state.shipper_country || null,
      origin: state.origin || null,
      port: state.port || null,
      total_value: state.total_value || null,
      goods_currency: state.goods_currency || null,
      sac: state.sac || false,
      fr_reference: state.fr_reference || null,
      sub_master: state.sub_master || null,
      pkg_type: state.pkg_type || null,
      country_of_origin: state.country_of_origin || null,
      cyber_vendor_account: state.cyber_vendor_account || null,
      customs_code: state.customs_code || null,
      cyber_importer_account: state.cyber_importer_account || null,
      importer_abn: state.importer_abn || null,
      importer_cac: state.importer_cac || null,
      cyber_supplier_account: state.cyber_supplier_account || null,
      supplier_customs_code: state.supplier_customs_code || null,
      is_scanned: state.is_scanned,
      parcel_no: state.parcel_no,
      status: state.status || null,
      zone: state.zone || null,
      suburb: state.suburb || null,
      state: state.state || null,
      country: state.country || null,
      height: state.height || null,
      length: state.length || null,
      volume_weighted: state.volume_weighted || null,
      delivery_date: state.delivery_date || null,
      price: state.price || null,
      company: state.company || null,
    };

    try {
      setapiLoading(true);
      // setBtnLoading(true);
      let response;

      if (PackageId === null) {
        response = await postRequest("package-model/", payload);
      } else {
        response = await patchRequest(`package-model/${PackageId}/`, payload);
      }

      if (response.data.success) {
        // Assuming the API response contains a `follow_up_date` field in `DD-MM-YYYY HH:mm` format

        // Optionally, you can do something with the `followUpDate` here, e.g., set it in the state:

        // Display success notification and reset form
        SuccessNotificationMsg(
          PackageId === null
            ? t("package_added_successfully")
            : t("package_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        // setBtnLoading(false);
        setapiLoading(false);
        setZones([]);
        navigate("/add-route");
      }
    } catch (error) {
      // if (PackageId === null) {
      //   ErrorNotificationMsg(
      //     // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
      //     t("error_in_adding_package")
      //   );
      // }
      // if (PackageId !== null && !error?.message) {
      //   ErrorNotificationMsg(
      //     // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
      //     t("error_in_updating_package")
      //   );
      // }

      // setBtnLoading(false);
      setapiLoading(false);
    }
  };

  const handleResidentSelectChange = (value) => {
    // getPermissionByRole(value);
    // setState({ ...state, work_on: value });
    setState({ ...state, status: value });
  };
  const handleDateChange = (date) => {
    // Assuming 'date' is already a Moment.js object representing both date and time
    const formattedDate = moment(date).format("DD-MM-YYYY HH:mm");
    setdeliverydate(formattedDate);
    setState({ ...state, delivery_date: formattedDate });
  };

  // const handleSearch = useCallback(
  //   debounce((value) => {
  //     // setLoading(true);

  //     const service = new window.google.maps.places.AutocompleteService();

  //     if (value !== "") {
  //       service.getPlacePredictions({ input: value }, (predictions, status) => {
  //         if (
  //           status === window.google.maps.places.PlacesServiceStatus.OK &&
  //           predictions
  //         ) {
  //           setOptions(
  //             predictions.map((prediction) => ({
  //               value: prediction.description,
  //               place_id: prediction.place_id,
  //             }))
  //           );
  //           setLoading(false);
  //         } else {
  //           setOptions([]);
  //           setLoading(false);
  //         }
  //       });
  //     } else {
  //       setOptions([]);
  //       setLoading(false);
  //       setState((prevstate) => ({
  //         ...prevstate,
  //         street_address: "",
  //         //suburb: "",
  //         // state: "",
  //         // postcode: "",
  //       }));
  //       form.setFieldsValue({
  //         street_address: "",
  //         // suburb: "",
  //         // state: "",
  //         // postcode: "",
  //       });
  //     }
  //   }, 300),
  //   []
  // );
  // Form reference for updating field values

  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            street_address: place.formatted_address,
            // suburb:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("locality")
            //   )?.long_name || "",
            // state:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("administrative_area_level_1")
            //   )?.short_name || "",
            // postcode:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("postal_code")
            //   )?.long_name || "",
          }));
          form.setFieldsValue({
            street_address: place.formatted_address,
            // suburb:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("locality")
            //   )?.long_name || "",
            // state:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("administrative_area_level_1")
            //   )?.short_name || "",
            // postcode:
            //   place.address_components.find((ac) =>
            //     ac.types.includes("postal_code")
            //   )?.long_name || "",
          });
        }
      });
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      // setLoading(true);

      const service = new window.google.maps.places.AutocompleteService();

      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            setLoading(false);
          } else {
            setOptions([]);
            setLoading(false);
          }
        });
      } else {
        setOptions([]);
        setLoading(false);
        setState((prevstate) => ({
          ...prevstate,
          street_address: "",
          //suburb: "",
          // state: "",
          // postcode: "",
        }));
        form.setFieldsValue({
          street_address: "",
          // suburb: "",
          // state: "",
          // postcode: "",
        });
      }
    }, 300),
    []
  );
  // const autocompleteRef = useRef(null); // Ref for the Autocomplete instance

  // const handlePlaceChanged = () => {
  //   const autocomplete = autocompleteRef.current; // Get the Autocomplete instance
  //   const place = autocomplete.getPlace(); // Get the place from Autocomplete API
  //   if (place && place.formatted_address) {
  //     setState({ ...state, customer_address: place.formatted_address });
  //     if (formRef.current) {
  //       formRef.current.setFieldsValue({ customer_address: place.formatted_address });
  //     }
  //   }
  // };
  return (
    <Spin spinning={apiLoading}>
      <div className="ListingTopBar ">
        <div className="pagenamewrap">
          <div className="pagename">
            {PackageId ? (
              <h3>{t("Edit Package")}</h3>
            ) : (
              <h3>{t("Add Package")}</h3>
            )}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/add-route"> {t("Add Route")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {PackageId ? t("Edit Package") : t("Add Package")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={libraries}
      >
        <section className="grid-sec FormSection Container">
          <div className="FormBody">
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Collapse
                defaultActiveKey={[
                  "1",
                  "2",
                  "3",
                  "4",
                  // "5",
                  // "6",
                  // "7",
                  // "8",
                  // "9",
                  // "10",
                  // "11",
                  // "12",
                  // "13",
                ]}
              >
                <Panel
                  header="1. Customer Details"
                  key="1"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={2} className="TextFeild">
                      <Form.Item
                        name="hawb"
                        label={t("pl_HAWB")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_HAWB")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z0-9\s]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_HAWB")}
                          type="text"
                          name="hawb"
                          onChange={handleInputChange}
                          value={state.hawb}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_code"
                        label={t("pl_Customer_Code")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Customer_Code")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Customer_Code")}
                          name="customer_code"
                          value={state.customer_code}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_name"
                        label={t("pl_Customer_Name")}
                        rules={[
                          {
                            required: true,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Customer_Name")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_Customer_Name")}
                          name="customer_name"
                          value={state.customer_name}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_phone"
                        label={t("label_phoneNumber_customer")}
                        placeholder={t("pl_contact_num_customer")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     validator: validatePhoneNumber,
                        //     message: <Trans> {t("val_contact_num_customer")}</Trans>,
                        //   },
                        // ]}
                      >
                        <PhoneInput
                          country={"au"}
                          onlyCountries={["au"]}
                          className="PhoneSection"
                          value={state.customer_phone}
                          onChange={(phone) =>
                            setState({ ...state, customer_phone: phone })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      {/* <FormItem
                        name="customer_address"
                        label={t("pl_Customer_Address")}
                        rules={[
                          {
                            required: true,

                            message: <Trans>{t("val_Customer_Address")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_Customer_Address")}
                          name="customer_address"
                          value={state.customer_address}
                          onChange={handleInputChange}
                          type="text"
                        />
                      </FormItem> */}
                      <Form.Item
                        name="customer_address"
                        label="Customer Address"
                        rules={[
                          {
                            required: true,
                            message: "Please enter the customer address",
                          },
                        ]}
                      >
                        {/* <Autocomplete
                          onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)} // Store Autocomplete instance in ref
                          onPlaceChanged={handlePlaceChanged} // Call this when the place changes
                        >
                          <Input
                            placeholder="Enter customer address"
                            name="customer_address"
                            value={state.customer_address}
                            onChange={(e) => setState({ ...state, customer_address: e.target.value })}
                          />
                        </Autocomplete> */}
                        <AutoComplete
                          id="customer_address"
                          placeholder={t("search_company_address")}
                          options={options}
                          onSearch={handleSearch}
                          onSelect={handleSelect}
                          value={state.customer_address}
                          onChange={(value) => {
                            setState((prevstate) => ({
                              ...prevstate,
                              customer_address: value,
                            }));
                            form?.setFieldsValue({
                              customer_address: value,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={2} className="TextFeild">
                      <FormItem
                        name="parcel_no"
                        label={t("pl_parcel_no")}
                        // rules={[
                        //   // {
                        //   //   required: true,
                        //   //   message: <Trans>{t("val_parcel_no")}</Trans>,
                        //   // },
                        //   {
                        //     pattern: /^[0-9]+$/,
                        //     message: <Trans>{t("val_parcel_no_invalid")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("Parcel Number")}
                          name="parcel_no"
                          disabled
                          value={state?.parcel_no}
                          onChange={handleInputChange}
                          type="text"
                        />
                      </FormItem>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={2}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="status"
                        label={t("label_status")}
                        // prefix={<User />}
                        value={state?.status}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_role")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          showArrow
                          placeholder={t("pl_select_status")}
                          // prefix={<User />}
                          disabled
                          onChange={(value) =>
                            handleResidentSelectChange(value)
                          }
                        >
                          <Option key="Not Scanned" value="Not Scanned">
                            Not Scanned
                          </Option>
                          <Option
                            key="Received in Depo"
                            value="Received in Depo"
                          >
                            Received in Depo
                          </Option>
                          <Option key="In Transit" value="In Transit">
                            In Transit
                          </Option>
                          <Option
                            key="Loaded by Driver"
                            value="Loaded by Driver"
                          >
                            Loaded by Driver
                          </Option>
                          <Option key="Delivered" value="Delivered">
                            Delivered
                          </Option>
                          <Option key="Failed Delivery" value="Failed Delivery">
                            Failed Delivery
                          </Option>
                          <Option
                            key="RTS- Return to Sender"
                            value="RTS- Return to Sender"
                          >
                            RTS- Return to Sender
                          </Option>
                          <Option
                            key="RD- Return to depo"
                            value="RD- Return to depo"
                          >
                            RD- Return to depo
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={3}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="delivery_date"
                        label={t("pl_package_delivery_date")}
                      >
                        <DatePicker
                          // format="DD-MM-YYYY"
                          placeholder={t("pl_date")}
                          format="DD-MM-YYYY HH:mm"
                          showTime={true}
                          allowClear={false}
                          value={deliverydate}
                          onChange={handleDateChange}
                          // style={{ width: "170px" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("pl_is_scanned")}
                        name="is_scanned"
                        valuePropName="checked"
                        // required
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_is_scanned")}</Trans>,
                        //   },
                        //   () => ({
                        //     validator(_, value) {
                        //       if (!value) {
                        //         return Promise.reject(
                        //           new Error(t("Please Is Scanned"))
                        //         );
                        //       }
                        //       return Promise.resolve();
                        //     },
                        //   }),
                        // ]}
                      >
                        <Checkbox
                          onChange={handleCheckboxChange}
                          checked={checked}
                        ></Checkbox>
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      <Form.Item
                        // style={{ margin: "30px" }}
                        className="BrowsButtonSec"
                        label={t("pl_visited")}
                        name="visited"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_visited")}</Trans>,
                          },
                          () => ({
                            validator(_, value) {
                              if (!value) {
                                return Promise.reject(
                                  new Error(t("Please visited"))
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Checkbox
                          onChange={handleCheckboxvisitedChange}
                          checked={checked}
                        ></Checkbox>
                      </Form.Item>
                    </Col> */}
                    {/* <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      <Form.Item
                        // style={{ margin: "30px" }}
                        className="BrowsButtonSec"
                        label={t("pl_departed")}
                        name="departed"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_departed")}</Trans>,
                          },
                          () => ({
                            validator(_, value) {
                              if (!value) {
                                return Promise.reject(
                                  new Error(t("Please departed"))
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Checkbox
                          onChange={handleCheckboxdepartedChange}
                          checked={checked}
                        ></Checkbox>
                      </Form.Item>
                    </Col> */}
                  </Row>
                </Panel>
                <Panel
                  header="2. Address Details"
                  key="2"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="country"
                        label={t("pl_country")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_country")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          placeholder="Select Country"
                          name="country"
                          value={state?.country}
                          showArrow
                          showSearch
                          // allowClear
                          onChange={handleCountryChnage}
                          optionFilterProp="children"
                        >
                          {countries.map((Country) => (
                            <Option key={Country.id} value={Country.id}>
                              {Country.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="state"
                        label={t("pl_state")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("Please select state")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          name="state"
                          label={t("pl_state")}
                          placeholder={t("pl_select_state")}
                          value={state.state}
                          onChange={handleStateSelectChange}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                        >
                          {states.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="zone"
                        label={t("pl_zone")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_select_zone")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          placeholder={t("pl_select_zone")}
                          showArrow
                          showSearch
                          name="zone"
                          value={state?.zone}
                          optionFilterProp="children"
                          onChange={handleZoneChange}
                        >
                          {zones.map((zone) => (
                            <Option key={zone.id} value={zone.id}>
                              {zone.zone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="company"
                        label={t("pl_company")}
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>{t("val_company_onboarding")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("pl_select_company")}
                          showArrow
                          showSearch
                          name="company"
                          value={state?.company}
                          optionFilterProp="children"
                          onChange={handleCompanyChange}
                        >
                          {companyList.map((company) => (
                            <Option key={company.id} value={company.id}>
                              {company.company_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      {/* <Form.Item
                        name="suburb"
                        label={t(" Suburb")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Please select suburb")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Suburb"
                          name="suburb"
                          value={state.suburb}
                          showArrow
                          onChange={handleSuburbChange}
                          showSearch
                          optionFilterProp="children"
                        >
                          {suburbList?.map((suburb) => (
                            <Option key={suburb.id} value={suburb.id}>
                              {suburb.area}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item> */}
                      <Form.Item
                        name="suburb"
                        label={t("pl_suburb")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: 'Please Select A Suburb'
                        //   }
                        // ]}
                      >
                        <AutoComplete
                          className="autoComplete"
                          //onSelect={onSelectBilling}
                          onSearch={onSearchBilling}
                          value={state.suburb}
                          optionFilterProp="children"
                          allowClear
                          placeholder={t("pl_select_subrub")}
                          onChange={handleSuburbSearchChange}
                          disabled={!state.zone}
                        >
                          {suburbSearchList.map((option) => (
                            <Option key={option.id} value={option.id}>
                              {option.area}
                            </Option>
                          ))}
                        </AutoComplete>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      {/* <Form.Item
                        name="postcode"
                        label={t("pl_Postcode")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_Postcode")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: <Trans>{t("val_parcel_no_invalid")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="postcode"
                          value={state.postcode}
                          onChange={handleInputChange}
                          placeholder={t("val_Postcode")}
                        />
                      </Form.Item> */}
                      <Form.Item
                        name="postcode"
                        label={t("pl_Postcode")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_Postcode")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("pl_enter_select_postcode")}
                          name="postcode"
                          value={state?.postcode}
                          showArrow
                          onChange={handlePostCodeChange}
                          showSearch
                          optionFilterProp="children"
                        >
                          {postCodes?.map((postcode) => (
                            <Option key={postcode.id} value={postcode.id}>
                              {postcode.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} className="TextFeild">
                      <Form.Item
                        name="description_of_goods"
                        label={t("pl_Description_goods")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Description_goods")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="description_of_goods"
                          value={state.description_of_goods}
                          onChange={handleInputChange}
                          placeholder={t("pl_Description_goods")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="count"
                        label={t("pl_Count")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Count")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="count"
                          value={state.count}
                          onChange={handleInputChange}
                          placeholder={t("pl_Count")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="">
                      <Form.Item
                        name="landed"
                        label={t("pl_Landed")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Landed")}</Trans>,
                        //   },
                        // ]}
                      >
                        {/* <Input
                          type="text"
                          name="landed"
                          value={state.landed}
                          onChange={handleInputChange}
                          placeholder={t("val_Landed")}
                        /> */}
                        <Radio.Group
                          onChange={handleInputChange}
                          value={state.landed}
                          style={{ display: "flex" }}
                          name="landed"
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="weight"
                        label={t("pl_Weight")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Weight")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="weight"
                          value={state.weight}
                          onChange={handleWeightChange}
                          placeholder={t("pl_Weight")}
                          // disabled={!state.zone || !state.company} // Disable if zone or company is not selected
                        />
                      </Form.Item>
                      {/*    <Form.Item
                        name="weight"
                        label={t("pl_Weight")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_Weight")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("val_Weight")}
                          name="weight"
                          value={state.weight}
                          showArrow
                          onChange={handleWeightChange}
                          showSearch
                          optionFilterProp="children"
                        >
                          {weightList?.map((weight) => (
                            <Option key={weight.id} value={weight.id}>
                              {weight.unit_of_measurement}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                               */}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item name="price" label={t("pl_price")}>
                        <Input
                          type="text"
                          name="price"
                          value={state?.price}
                          onChange={handleInputChange}
                          disabled
                          placeholder={t("Price By Weight")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="height"
                        label={t("pl_Height")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Height")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="height"
                          value={state.height}
                          onChange={handleInputChange}
                          placeholder={t("pl_Height")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="length"
                        label={t("pl_Length")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Length")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="length"
                          value={state.length}
                          onChange={handleInputChange}
                          placeholder={t("pl_Length")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="volume_weighted"
                        label={t("pl_Volume_Weighted")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Volume_Weighted")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="volume_weighted"
                          value={state.volume_weighted}
                          onChange={handleInputChange}
                          placeholder={t("pl_Volume_Weighted")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="3. Shipper Data"
                  key="3"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_code"
                        label={t("pl_Shipper_Code")}
                      >
                        <Input
                          type="text"
                          name="shipper_code"
                          value={state.shipper_code}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Code")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_name"
                        label={t("pl_Shipper_Name")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_Name")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_name"
                          value={state.shipper_name}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Name")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_address"
                        label={t("pl_Shipper_Address")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Shipper_Address")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="shipper_address"
                          value={state.shipper_address}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Address")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_city"
                        label={t("pl_Shipper_City")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_City")} </Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_city"
                          placeholder={t("pl_Shipper_City")}
                          value={state.shipper_city}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_state"
                        label={t("pl_Shipper_State")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_State")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_state"
                          placeholder={t("pl_Shipper_State")}
                          value={state.shipper_state}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_postcode"
                        label={t("pl_Shipper_Postcode")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Shipper_Postcode")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_postcode"
                          value={state.shipper_postcode}
                          placeholder={t("pl_Shipper_Postcode")}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    {/* <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                  <Form.Item
                    name="actual_distance_computation_method"
                    label={t("pl_Actual_Distance_Computation_Method")}
                    rules={[
                      {
                        required: true,
                        message: (
                          <Trans>
                            {t("val_Actual_Distance_Computation_Method")}
                          </Trans>
                        ),
                      },
                    ]}
                  >
                    <Input
                      name="actual_distance_computation_method"
                      value={state.actual_distance_computation_method}
                      onChange={handleInputChange}
                      placeholder={t("val_Actual_Distance_Computation_Method")}
                    />
                  </Form.Item>
                </Col> */}
                    {/* <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="actual_distance_computation_method"
                        label={t("pl_Actual_Distance_Computation_Method")}
                        value={state.actual_distance_computation_method}
                        // prefix={<User />}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_role")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          showArrow
                          // mode="multiple"
                          placeholder={t(
                            "val_Actual_Distance_Computation_Method"
                          )}
                          onChange={(value) =>
                            handleActualDistanceSelectChange(value)
                          }
                        >
                          <Option key="1" value="None">
                            None
                          </Option>
                          <Option key="2" value="Estimated">
                            Estimated
                          </Option>
                          <Option key="2" value="Insufficient Data">
                            Insufficient Data
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col> */}
                    {/* <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      <Form.Item
                        name="actual_drive_time_computation_method"
                        label={t("pl_Actual_Drive_Time_Computation_Method")}
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>
                                {t("val_Actual_Drive_Time_Computation_Method")}
                              </Trans>
                            ),
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          // mode="multiple"
                          placeholder={t(
                            "val_Actual_Drive_Time_Computation_Method"
                          )}
                          onChange={(value) =>
                            handleActualDriveTimeSelectChange(value)
                          }
                        >
                          <Option key="1" value="None">
                            None
                          </Option>
                          <Option key="2" value="Mixed">
                            Mixed
                          </Option>
                          <Option key="2" value="Insufficient Data">
                            Insufficient Data
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col> */}

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_country"
                        label={t("pl_Shipper_Country")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_Country")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          name="shipper_country"
                          value={state.shipper_country}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Country")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="origin"
                        label={t("pl_Origin")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Origin")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="origin"
                          value={state.origin}
                          onChange={handleInputChange}
                          placeholder={t("pl_Origin")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="port"
                        label={t("pl_Port")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Port")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="port"
                          value={state.port}
                          onChange={handleInputChange}
                          placeholder={t("pl_Port")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="total_value"
                        label={t("pl_Total_Value")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Total_Value")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="total_value"
                          value={state.total_value}
                          onChange={handleInputChange}
                          placeholder={t("pl_Total_Value")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="goods_currency"
                        label={t("pl_Goods_Currency")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Goods_Currency")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="goods_currency"
                          value={state.goods_currency}
                          onChange={handleInputChange}
                          placeholder={t("pl_Goods_Currency")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="4. Additional Info"
                  key="4"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="">
                      <Form.Item
                        name="sac"
                        label={t("pl_SAC")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_SAC")}</Trans>,
                        //   },
                        // ]}
                      >
                        {/* <Input
                          placeholder={t("val_SAC")}
                          name="sac"
                          value={state.sac}
                          onChange={handleInputChange}
                        /> */}
                        <Radio.Group
                          onChange={handleInputChange}
                          value={state.sac}
                          style={{ display: "flex" }}
                          name="sac"
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="fr_reference"
                        label={t("pl_FR_Reference")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_FR_Reference")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_FR_Reference")}
                          name="fr_reference"
                          value={state.fr_reference}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="sub_master"
                        label={t("Sub Master")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_SubMaster")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("Sub Master")}
                          name="sub_master"
                          value={state.sub_master}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="pkg_type"
                        label={t("pl_Pkg_Type")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Pkg_Type")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Pkg_Type")}
                          name="pkg_type"
                          value={state.pkg_type}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="country_of_origin"
                        label={t("pl_Country_Origin")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Country_Origin")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Country_Origin")}
                          name="country_of_origin"
                          value={state.country_of_origin}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_vendor_account"
                        label={t("pl_Cyber_Vendor_Account")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Vendor_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Cyber_Vendor_Account")}
                          name="cyber_vendor_account"
                          value={state.cyber_vendor_account}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      <Form.Item
                        name="phone"
                        label={t("label_phoneNumber")}
                        placeholder={t("pl_contact_num")}
                        rules={[
                          {
                            required: true,
                            validator: validatePhoneNumber,
                            message: <Trans> {t("val_contact_num")}</Trans>,
                          },
                        ]}
                      >
                        <PhoneInput
                          // country={"in"}
                          country={"au"}
                          className="PhoneSection"
                          value={state.phone}
                          onChange={(phone) =>
                            setState({ ...state, phone: phone })
                          }
                        />
                      </Form.Item>
                    </Col> */}
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customs_code"
                        label={t("pl_Customs_Code")}
                      >
                        <Input
                          name="customs_code"
                          placeholder={t("pl_Customs_Code")}
                          onChange={handleInputChange}
                          value={state.customs_code}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_importer_account"
                        label={t("pl_Cyber_Importer_Account")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Importer_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="cyber_importer_account"
                          placeholder={t("pl_Cyber_Importer_Account")}
                          onChange={handleInputChange}
                          value={state.cyber_importer_account}
                          type="text"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="importer_abn"
                        label={t("pl_Importer_ABN")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Importer_ABN")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="importer_abn"
                          placeholder={t("pl_Importer_ABN")}
                          onChange={handleInputChange}
                          value={state.importer_abn}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="importer_cac"
                        label={t("pl_Importer_CAC")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Importer_CAC")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="importer_cac"
                          placeholder={t("pl_Importer_CAC")}
                          onChange={handleInputChange}
                          value={state.importer_cac}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_supplier_account"
                        label={t("pl_Cyber_Supplier_Account")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Supplier_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="cyber_supplier_account"
                          placeholder={t("pl_Cyber_Supplier_Account")}
                          onChange={handleInputChange}
                          value={state.cyber_supplier_account}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="supplier_customs_code"
                        label={t("pl_Supplier_Customs_Code")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: (
                        //       <Trans>{t("val_Supplier_Customs_Code")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="supplier_customs_code"
                          placeholder={t("pl_Supplier_Customs_Code")}
                          onChange={handleInputChange}
                          value={state.supplier_customs_code}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div
                    className="ModalPopupFooter"
                    style={{ float: "inline-end" }}
                  >
                    <ButtonField
                      style={{ background: "white" }}
                      className="CancelGradiantBtn"
                      type="primary"
                      htmlType="button"
                      size="medium"
                      label="Cancel"
                      onClick={() => navigate("/package")}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Submit"
                      label={t("save")}
                      // loading={btnLoading}
                    />
                  </div>
                </Panel>
                {/* <Panel
                  header="5. Additional Info"
                  key="5"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                  
                  </Row>
                 
                </Panel> */}
              </Collapse>
            </Form>
          </div>
        </section>
      </LoadScript>
    </Spin>
  );
}
